// extracted by mini-css-extract-plugin
export default {"subFooter":"Footer_subFooter__6Y2J7","footer":"Footer_footer__PxxIj","text":"Footer_text__LFzxy","link":"Footer_link__sgKeT"};